import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentBooking: null,
  bookingStatus: null, // 'pending_partner_acceptance', 'accepted_by_partner', etc.
  notifications: [],
  unreadCount: 0,
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setCurrentBooking: (state, action) => {
      state.currentBooking = action.payload;
    },
    updateBookingStatus: (state, action) => {
      const { status, partner } = action.payload;
      state.bookingStatus = status;
      if (state.currentBooking) {
        state.currentBooking.status = status;
        if (partner) {
          state.currentBooking.partner = partner;
        }
      }
    },
    clearCurrentBooking: (state) => {
      state.currentBooking = null;
      state.bookingStatus = null;
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
    },
    markNotificationRead: (state, action) => {
      const notification = state.notifications.find((n) => n.id === action.payload);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllNotificationsRead: (state) => {
      state.notifications.forEach((n) => (n.read = true));
      state.unreadCount = 0;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },
  },
});

export const {
  setCurrentBooking,
  updateBookingStatus,
  clearCurrentBooking,
  addNotification,
  markNotificationRead,
  markAllNotificationsRead,
  clearNotifications,
} = bookingSlice.actions;

export default bookingSlice.reducer;
